module.exports = __webpack_public_path__ + "img/bottomImg.22808628.png";